var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPayPassIcon(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 24,
    viewBox: "0 0 20 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_715_6445)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15.143 1.28571C17.0237 4.54326 18.0139 8.23849 18.0139 12C18.0139 15.7615 17.0237 19.4567 15.143 22.7143M10.4287 3.64285C11.8957 6.18374 12.668 9.06602 12.668 12C12.668 14.934 11.8957 17.8162 10.4287 20.3571M5.92871 5.80713C6.98945 7.66394 7.54789 9.77022 7.54789 11.9143C7.54789 14.0583 6.98945 16.1646 5.92871 18.0214M1.42871 8.14285C2.19318 9.29983 2.59847 10.6362 2.59847 12C2.59847 13.3638 2.19318 14.7002 1.42871 15.8571",
    stroke: "#1C1C20",
    strokeWidth: 2.57143,
    strokeLinecap: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_715_6445"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 24,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPayPassIcon);
export default __webpack_public_path__ + "static/media/pay-pass-icon.8a4dad00a606fc8a0de7c18fe2c425bd.svg";
export { ForwardRef as ReactComponent };